import { render, staticRenderFns } from "./DigitalCopyrightRegistrationEdit.vue?vue&type=template&id=08324ebc&scoped=true"
import script from "./DigitalCopyrightRegistrationEdit.vue?vue&type=script&lang=js"
export * from "./DigitalCopyrightRegistrationEdit.vue?vue&type=script&lang=js"
import style0 from "./DigitalCopyrightRegistrationEdit.vue?vue&type=style&index=0&id=08324ebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08324ebc",
  null
  
)

export default component.exports